'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _InspirationLayouts = require('./InspirationLayouts.scss');

var _InspirationLayouts2 = _interopRequireDefault(_InspirationLayouts);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactRedux = require('react-redux');

var _customize = require('redux/modules/customize');

var _media = require('utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  InspirationLayouts: {
    displayName: 'InspirationLayouts'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/InspirationLayouts.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var InspirationLayouts = _wrapComponent('InspirationLayouts')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    // locale: state.language.locale,
    siteConfigs: state.info.siteConfigs
  };
}, { logCustomizeTrip: _customize.logCustomizeTrip }), _dec2 = (0, _reactCssModules2.default)(_InspirationLayouts2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(InspirationLayouts, _Component);

  function InspirationLayouts() {
    (0, _classCallCheck3.default)(this, InspirationLayouts);
    return (0, _possibleConstructorReturn3.default)(this, (InspirationLayouts.__proto__ || (0, _getPrototypeOf2.default)(InspirationLayouts)).apply(this, arguments));
  }

  (0, _createClass3.default)(InspirationLayouts, [{
    key: 'onClick',

    // constructor(props) {
    //   super(props);
    //   this.getLink = this.getLink.bind(this);
    // }
    value: function onClick(id) {
      if (this.props.siteConfigs.customizeInspiration) {
        this.props.logCustomizeTrip(id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const {layouts, siteConfigs, isCity, tourType, maxWidthInner} = this.props;
      // const {layouts, siteConfigs, maxWidthInner} = this.props;
      var _props = this.props,
          layouts = _props.layouts,
          siteConfigs = _props.siteConfigs;

      if (!layouts || layouts.length === 0) {
        return _react3.default.createElement('div', null);
      }
      // if (isCity) {
      //   return (
      //     <div>
      //       {layouts.map((layout, i) => {
      //         return (
      //           <div key={`row-${i}`} styleName={maxWidthInner ? 'max-width-inner' : 'inner'}>
      //             {
      //               layout.columns.map((column, index) => {
      //                 return (
      //                   <Link key={index} to={tourType ? `/to/${column.city.link}?tags=${tourType}` : `/tour?location=${column.city.link}`} styleName={column.size === 2 ? 'see-ins-box-2' : 'see-ins-box-1'}>
      //                     <div styleName="shadow"></div>
      //                     <div styleName="image" style={{'backgroundImage': `url(${column.city.cover})`}}></div>
      //                     <h3 styleName="inspiration-name">{column.city.name}</h3>
      //                   </Link>
      //                 );
      //               })
      //             }
      //           </div>
      //         );
      //       })}
      //     </div>
      //   );
      // }
      return _react3.default.createElement(
        'div',
        null,
        layouts.map(function (layout) {
          return _react3.default.createElement(
            'div',
            { key: layout._id, styleName: 'float-parent' },
            layout.columns.map(function (column, index) {
              if (!column.inspiration_id) return _react3.default.createElement('a', null);
              // console.log('layout: ', `see-ins-box-size-${column.size}-length-${layout.columns.length}`);
              return _react3.default.createElement(
                'div',
                { key: column.inspiration_id._id, styleName: 'see-ins-box-size-' + column.size + '-length-' + layout.columns.length },
                _react3.default.createElement(
                  _Link2.default,
                  { key: index, to: siteConfigs.customizeInspiration ? '/customize' : '/inspiration/' + column.inspiration_id.slug, styleName: 'see-ins-link', onClick: _this2.onClick.bind(_this2, column.inspiration_id._id) },
                  _react3.default.createElement('div', { styleName: 'shadow' }),
                  _react3.default.createElement('div', { styleName: 'image', style: { 'backgroundImage': 'url(' + (0, _media.path)(column.inspiration_id.thumbnail_image, column.size === 1 ? 'inspCol1' : 'inspCol2') + ')' } }),
                  _react3.default.createElement(
                    'h3',
                    { styleName: 'inspiration-name' },
                    column.inspiration_id.name
                  )
                )
              );
            })
          );
        })
      );
    }
  }]);
  return InspirationLayouts;
}(_react2.Component), _class2.propTypes = {
  layouts: _react2.PropTypes.array,
  // locale: PropTypes.string,
  siteConfigs: _react2.PropTypes.object,
  logCustomizeTrip: _react2.PropTypes.func,
  // isCity: PropTypes.bool,
  // tourType: PropTypes.string,
  maxWidthInner: _react2.PropTypes.bool
}, _class2.defaultProps = {
  layouts: [],
  // isCity: false,
  maxWidthInner: false }, _temp)) || _class) || _class));

exports.default = InspirationLayouts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/InspirationLayouts.js
// module id = 1533
// module chunks = 47